var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPeicarSimpleSvg(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 172,
    height: 111,
    viewBox: "0 0 172 111",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "isotipo 1_peicar 1"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M89.5875 45.0167C84.3336 28.6387 68.9293 16.8386 50.8204 17.0962C28.8478 17.4082 11.0748 35.7232 11.2987 57.7962C11.5189 79.8583 29.3895 97.6764 51.4054 97.6764C61.1513 97.6764 70.3989 94.5423 77.0359 88.3756C94.7764 71.8997 144.474 18.8374 144.474 18.8374C148.294 14.898 154.949 17.6149 154.949 23.1178V99.1274",
    stroke: "white",
    strokeWidth: 8,
    strokeMiterlimit: 10
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPeicarSimpleSvg);
export default __webpack_public_path__ + "static/media/peicarSimpleSvg.763e114ccc55692ddac2c13a0d7a2492.svg";
export { ForwardRef as ReactComponent };